











import { Vue, Component, Prop } from "vue-property-decorator";
import widgets from "../../package/widgets";
import wgetMgr from "../widgets/wgetMgr";

@Component({
  name: "WidgetRender",
  components: { ...widgets }
})
export default class WidgetRender extends Vue {
  @Prop({
    required: true,
    type: Object
  })
  private widget!: App.WebForm.Widget;

  @Prop({
    required: true,
    type: Object
  })
  private model!: any;

  mounted() {
    wgetMgr.setWidgetById(this.widget.id, this.$refs[this.widget.id]);
  }
}
